/**
 * @file: 渲染标签标记
 * @author: xiaolong.huang@dmall.com
 */

import * as Utils from '../../../utils/util';
import * as FrontCubeData from '../../../frontCubeData/index';

export function renderLayerTag(cube: CubeNode): void {
    let moduleTagTextEl: JQuery = cube.jView.find('.tag-value');
    let moduleTagIcon: JQuery = cube.jView.find('.module-tag');
    let checkIcon: JQuery = cube.jView.find('.not-check');
    let moduleTagText: string = FrontCubeData.getValue(cube.id, 'moduleTag') || '';
    let recheckFlag: number = FrontCubeData.getNumberValue(cube.id, 'recheckFlag') || 1;

    if (recheckFlag === 2) {
        checkIcon.addClass('not-check--show');
    }
    else {
        checkIcon.removeClass('not-check--show');
    }


    if (moduleTagText) {
        moduleTagIcon.addClass('module-tag--show');
    }

    moduleTagTextEl.text(moduleTagText);
}
